export default __webpack_public_path__ + "static/media/bx_error-circle.88900527.svg";